"use strict";

exports.__esModule = true;
exports.getFieldType = getFieldType;

var _react = _interopRequireDefault(require("react"));

var _ = require("./");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function getFieldType(props) {
  const type = props && props.schema && props.schema._type || props && props.schema && props.schema.type;
  const registry = props && props.registry || (0, _.getDefaultRegistry)();
  const fieldtypes = registry.fieldtypes,
        fields = registry.fields;
  let field = {};

  if (type && type in fieldtypes) {
    const getField = fieldtypes[type];
    field = getField(_extends({}, props));
    field.schema = _extends({}, field.schema, {
      _type: type
    });
  } else {
    field = props;
  }

  return field;
}